class SizeChart extends HTMLElement {
  constructor() {
    super();
    this.isInches = false;
    this.controller = new AbortController();
  }

  connectedCallback() {
    this.checkbox = this.querySelector('[data-size-chart-toggle]');
    this.sizeChartClass = this.dataset.sizeChart;

    if (this.checkbox) {
      this.checkbox.addEventListener(
        'change',
        () => this.updateUnit(this.sizeChartClass),
        { signal: this.controller.signal }
      );
    }
  }

  disconnectedCallback() {
    this.controller.abort();
  }

  updateUnit(size_chart) {
    this.isInches = this.checkbox.checked;

    const table = this.querySelectorAll(`.${size_chart} tbody tr`);
    table.forEach((row) => {
      const columns = row.querySelectorAll('td');
      columns.forEach((column, index) => {
        if (index > 0) {
          if (!column.dataset.original) {
            column.dataset.original = column.textContent.trim();
          }
          const trimmed = column.dataset.original.trim();
          const original = Number(trimmed);
          if (trimmed.length > 0 && !isNaN(original)) {
            column.textContent = this.isInches
              ? (original / 2.54).toFixed(1).replace(/\.0$/, '')
              : column.dataset.original;
          }
        }
      });
    });
  }
}

if (!customElements.get('size-chart')) {
  customElements.define('size-chart', SizeChart);
}
